<template>
  <div id="app-mil">
    <LmsMssComponent endpoint="getmetar" source="data_mil" :show_header="true" />
  </div>
</template>

<script>
import LmsMssComponent from "@/components/LmsMssComponent";

export default {
  name: 'App',
  components: {
    LmsMssComponent,
  }
}
</script>
